module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-36e5459c.png";